import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { reactive, computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getMerchandis4Sup, getBranchSource, addSupMer } from '@/request';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'netplatform-addprodmodal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    dept: {
      type: Object,
      default: () => ({})
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    storageType: Number,
    selectedData: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const route = useRoute();
    console.log(route);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const formRef = ref();
    const form = reactive({
      branchId: '',
      merInfo: '',
      manufacture: ''
    });
    const branchList = ref([]);
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _branchList$value$, _table$value;

        form.merInfo = '';
        form.manufacture = '';
        form.branchId = (_branchList$value$ = branchList.value[0]) === null || _branchList$value$ === void 0 ? void 0 : _branchList$value$.branchId;
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }

      if (props.storageType === 1) {
        columns[columns.length - 1].title = '货主库存';
        table.value.reloadColumn(columns);
      }
    }, {
      flush: 'post'
    });
    getBranchSource({
      supplierId: route.query.supplierId
    }).then(data => {
      if (data !== null && data !== void 0 && data.length) {
        var _data$;

        branchList.value = data;
        form.branchId = (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.branchId;
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      } // addSupMer({
      //   __warn: true,
      //   structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id,
      //   merInfo: selectRows
      //     .map((i) => `${i.branchId},${i.prodNo},${i.prodId}`)
      //     .join(';'),
      //   supplierId: props.supplierId
      // }).then((data) => {
      //   if (data.success) {
      //     ElMessage.success(data.msg);
      //     visible.value = false;
      //     emit('success');
      //   }
      // });


      let body = {
        supplierId: route.query.supplierId,
        prodNos: selectRows.map(v => v.prodNo).join()
      };
      Axios.post('/admin/supplier/addSpiderkeyword', body).then(res => {
        let data = res.data;

        if (data.success) {
          ElMessage.success('操作成功');
          visible.value = false;
          emit('success');
        } else {
          ElMessage.error(data.msg);
        }
      });
    }

    const columns = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: '发货方',
      field: 'branchName',
      width: '200px',
      showOverflow: true
    }, {
      title: '药品编码',
      field: 'prodNo',
      width: '200px',
      showOverflow: true
    }, {
      title: '药品名称',
      field: 'prodName',
      width: '200px',
      showOverflow: true
    }, {
      title: '药品规格',
      field: 'prodSpecification',
      width: '150px',
      showOverflow: true
    }, {
      title: '生产厂家',
      field: 'manufacturer',
      width: '200px',
      showOverflow: true
    }, {
      title: '采购员',
      field: 'custGrossMargin',
      width: '100px',
      showOverflow: true
    }, {
      title: '中包装',
      field: 'midPackageQuantity',
      width: '100px',
      showOverflow: true
    }, {
      title: '单位',
      field: 'packageUnit',
      width: '100px',
      showOverflow: true
    }, {
      title: '库存',
      field: 'storageNumber',
      width: '100px',
      showOverflow: true
    }];
    const tableOptions = getVexTableProps({
      columns,
      'checkbox-config': {
        checkMethod: ({
          row
        }) => {
          return !props.selectedData.find(item => item.prodNo == row.prodNo);
        }
      },
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getMerchandis4Sup(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: route.query.supplierId
            }, form), {}, {
              __warn: true
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "添加药品",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "1200px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "branchId",
                label: "发货方"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.branchId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.branchId = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.shortName,
                      value: item.branchId,
                      key: item.branchId
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "branchId",
                label: "药品名"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.merInfo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.merInfo = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "branchId",
                label: "厂家"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.manufacture,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.manufacture = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                icon: "Search",
                onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), __props.modelValue ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};